module.exports = __webpack_public_path__ + "static/media/skråp-min.d3ed7a45.png";